import { RoiTableColumns, RoiTableRows } from './types'

export const PRICE_PER_SHARE = 250
export const MIN_SHARES = 1
export const MAX_SHARES = 100
export const MIN_SLIDER_POS = MIN_SHARES
export const MAX_SLIDER_POS = 40
export const WITH_BOLT_ADVANTAGE = 120

export const ROI_TABLE_ROW_KEYS: RoiTableRows[] = [
  RoiTableRows.ROI,
  RoiTableRows.ADVANTAGE_EL,
  RoiTableRows.ADVANTAGE_GAS,
  RoiTableRows.TOTAL
]

export const ROI_TABLE_COLUMN_KEYS: RoiTableColumns[] = [RoiTableColumns.PLENTY, RoiTableColumns.BOLT]
